"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildClassModifiers = buildClassModifiers;
exports.buildClassName = buildClassName;

function buildClassModifiers(baseClassName, modifiers) {
  return modifiers.map(function (modifier) {
    return "".concat(baseClassName, "--").concat(modifier);
  }).join(' ');
}

function buildClassName(baseClassName, modifiers) {
  if (!modifiers.length) {
    return baseClassName;
  }

  var classModifiers = buildClassModifiers(baseClassName, modifiers);
  return "".concat(baseClassName, " ").concat(classModifiers);
}